<template>
    <div>
        <div class>
            <Steps :active="2" :stepsShow=true align-center>
                <Step :title="$t('offering.offbase')" @click.native="on_click('offbaseAdd')" />
                <Step :title="$t('offering.offeringResources')" @click.native="on_click('offeringResourcesAdd')" />
                <Step :title="$t('offering.offconditionAdd')" @click.native="on_click('offconditionAdd')" />
                <Step :title="$t('offering.offnoticeAdd')" @click.native="on_click('offnoticeAdd')" />
                <Step :title="$t('offering.offpriceAdd')" @click.native="on_click('offpriceAdd')" />
                <Step :title="$t('offering.offinvestAdd')" @click.native="on_click('offinvestAdd')" />
                <Step :title="$t('offering.offabilityAdd')"  @click.native="on_click('offabilityAdd')" />
            </Steps>
        </div>
        <br/>
        <div class='divMessage'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ message }}</div>
        <br/>
        <el-card class="aui-card--fill"
                shadow="never">
                <el-form
                label-position="top"
                label-width="145px"
                :model="inServForm"
                ref="inServForm"
                :rules="dataRule"
                size="small">
            <el-row >
               <el-col :span="6">
                <!-- 开课前-->
                <el-col :span="12">
                        <el-form-item :label="$t('couse.couseq')" prop="deadLineDays" style="width: 90px; float: left;">
                                    <!-- <el-tooltip content="截止报名(替换)" placement="bottom" effect="light"> -->
                                        <el-input v-model.number="inServForm.deadLineDays" disabled
                                                  style="width: 90px;">
                                        </el-input>
                                   <!-- </el-tooltip> -->
                                </el-form-item>
                            </el-col>
                            <el-col :span="9">
                                <el-form-item prop="deadLineFlag" style="width: 60px; padding-left: 2.5px;">
                                    <span slot="label">&nbsp;&nbsp;&nbsp;</span>
                                    <!-- <el-tooltip content="截止报名(替换)" placement="bottom" effect="light"> -->
                                        <el-select v-model="inServForm.deadLineFlag" style="width: 60px;"
                                                   filterable disabled>
                                            <el-option v-for="item in cousedaylist"
                                                       :key="item.value"
                                                       :label="item.label"
                                                       :value="item.value">
                                            </el-option>
                                        </el-select>
                                    <!-- </el-tooltip> -->
                                </el-form-item>
                       </el-col>
              </el-col>
              <el-col :span="6">
                <!-- 启用等待名单-->
                <el-form-item :label="$t('couse.qiy')" prop="waitingListFlag">
                  <el-select v-model="inServForm.waitingListFlag" disabled>
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
                 <el-col :span="6">
                <!-- 允许店内替换-->
                <el-form-item :label="$t('couse.yxdealer')" prop="replaceUserFlag">
                  <el-tooltip content="截止替换时间与截止报名日期一致" placement="bottom" effect="light">
                  <el-select v-model="inServForm.replaceUserFlag" disabled>
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
                <el-col :span="6">
              </el-col>
            </el-row>
            <el-row >
                  <el-col :span="6" v-if="false">
                <!-- 允许重复报名-->
                <el-form-item :label="$t('couse.rxc')" prop="repeatRegistFlag">
                  <el-select v-model="inServForm.repeatRegistFlag" disabled>
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 限制撤销报名-->
                <el-form-item :label="$t('couse.xz')" prop="revokeRegistFlag">
                  <el-select v-model="inServForm.revokeRegistFlag" disabled>
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="inServForm.revokeRegistFlag == '10'">
                <!-- 限制撤销报名天数-->
                <el-form-item :label="$t('couse.xxc')"  prop="revokeRegistDays">
                  <el-input v-model="inServForm.revokeRegistDays" disabled
                            class="inputBox">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="1" v-if="false">
              <el-col :span="12">
                  <div class="location-layout"
                      v-if="inServForm.repeatRegistFlag == '20'">
                    <el-checkbox v-model="inServForm.repeatRegistRegisted" label="true" disabled
                    true-label="true" false-label="false"
                                size="medium"><span style="font-size:12px">状态为已报名的不可重复报名</span></el-checkbox>
                  </div>
                  <div class="location-layout"
                      v-if="inServForm.repeatRegistFlag == '20'">
                       <!-- label="状态为已完成的不可重复报名" -->
                    <el-checkbox v-model="inServForm.repeatRegistComplete" label="true" disabled
                    true-label="true" false-label="false"
                                ><span style="font-size:12px">状态为已完成的不可重复报名</span></el-checkbox>
                  </div>
                  <div class="location-layout"
                      v-if="inServForm.repeatRegistFlag == '20'">
                      <!-- label="状态为未完成的不可重复报名" -->
                    <el-checkbox v-model="inServForm.repeatRegistIncomplete" disabled
                    true-label="true" false-label="false"
                                label="true"
                                size="medium"><span style="font-size:12px">状态为未通过的不可重复报名</span></el-checkbox>
                  </div>
              </el-col>
            </el-row>
                 <!-- 基本信息 -->
                   <div class="opten-titlec">
            {{$t('couse.conditiontile')}}
          </div>
          <div style="margin-bottom:10px;">
            <span style="font-size: 8pt;">{{$t('couse.conditionnotice')}}</span></div>
            <el-table :data="infiledLists2"
                      :show-header="false"
                      style="width: 100%;text-align: left;"
                      class="el-table el-table"
                      :row-class-name="tableRowClassName"
                      :cell-style="cellStyle"
                      border
                      stripe
                      empty-text=" ">
              <el-table-column label="coursecode"
                              prop="options"
                              min-width="100px"
                              width="300px"
                              align="center">
                <template slot-scope="scope">
                  <span :id="'completeStatus' + scope.$index">{{$t('couse.allname')}}</span>
                </template>
              </el-table-column>
              <el-table-column label="coursecode"
                              prop="state"
                              min-width="180px"
                              width="400px"
                              align="center">
                <template slot-scope="scope">
                  <span :id="'completeStatus2' + scope.$index">{{$t('couse.allstate')}}</span>
                </template>
              </el-table-column>
              <el-table-column label="coursecode"
                              prop="optype"
                              min-width="80px"
                              align="center">
                <template slot-scope="scope">
                  <span :id="'completeStatus3' + scope.$index">{{$t('couse.alltype')}}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-table
                      :data="inServForm.courseConditionList"
                      id="download"
                      :show-header="false"
                      :cell-style="cellStylec"
                      border
                      stripe
                      empty-text=" "
                      >
              <el-table-column label=""
                              min-width="140px"
                              align="left">
                 <template slot-scope="scope">
                  <conditionShow @appenddata="appenddata"
                            @inputs="inputs"
                            :days="scope.row.days"
                            :inputvaluestrue22="scope.row.daysdisplay"
                            :inputvalues="scope.row.courseConditionList"
                            :inputvalues22="scope.row.optionIndex"
                            :inputvaluesfu="inServForm.courseBlendConditionList"
                            :inputindex="scope.$index"></conditionShow>
                </template>
              </el-table-column>
            </el-table>
                    <!------------------2020 06-09开始------------------------->
                    <template>
                        <el-row :gutter="1">
                            <el-col :span="12">
                                <el-form-item label="   ">
                                    <div class="dia">
                                        <el-radio disabled text-color="#303133" label="0" v-model="inServForm.offeringBlendRead"><span style="color: #303133;">{{ $t('couse.blendRead') }}</span></el-radio>
                                        <el-radio disabled text-color="#303133" label="1" @change="readFlagchange()" v-model="inServForm.offeringBlendRead"><span style="color: #303133;">{{ $t('couse.blendNread') }}</span>
                                        </el-radio>
                                    </div>
                                    <div style="margin-bottom:1px;">
                                        <span style="font-size: 8pt;">{{$t('couse.blendnotes')}}</span></div>
                                    <div style="margin-bottom:1px;" v-if="courseBlendDisplay==false && inServForm.offeringBlendRead=='0'">
                                        <span style="font-size: 12pt;">{{$t('couse.blendnotesmsg')}}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </template>
                    <div class="location-layout" v-if="inServForm.offeringBlendRead == '0'">
                        <div style="margin-bottom:1px;" v-if="courseBlendDisplay==true">
                        <el-table :data="infiledLists2"
                                  :show-header="false"
                                  style="width: 100%;text-align: left;"
                                  class="el-table el-table"
                                  :row-class-name="tableRowClassName"
                                  :cell-style="cellStyle"
                                  border
                                  stripe
                                  empty-text=" ">
                            <el-table-column label="coursecode"
                                             prop="options"
                                             min-width="100px"
                                             width="300px"
                                             align="center">
                                <template slot-scope="scope">
                                    <span :id="'completeStatus' + scope.$index">{{$t('couse.allname')}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="coursecode"
                                             prop="state"
                                             min-width="180px"
                                             width="400px"
                                             align="center">
                                <template slot-scope="scope">
                                    <span :id="'completeStatus2' + scope.$index">{{$t('couse.allstate')}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="coursecode"
                                             prop="optype"
                                             min-width="80px"
                                             align="center">
                                <template slot-scope="scope">
                                    <span :id="'completeStatus3' + scope.$index">{{$t('couse.alltype')}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-table
                                :data="inServForm.courseBlendConditionList"
                                id="download1"
                                :show-header="false"
                                :cell-style="cellStylec"
                                border
                                stripe
                                empty-text=" "
                        >
                            <el-table-column label=""
                                             min-width="140px"
                                             align="left">
                                <template slot-scope="scope">
                                    <blendconditionShow @appenddata="appenddata"
                                                        @inputs="inputs"
                                                        :days="scope.row.days"
                                                        :inputvaluestrue22="scope.row.daysdisplay"
                                                        :inputvalues="scope.row.courseConditionList"
                                                        :inputvalues22="scope.row.optionIndex"
                                                        :inputvaluesfu="inServForm.courseBlendConditionList"
                                                        :inputindex="scope.$index"></blendconditionShow>
                                </template>
                            </el-table-column>
                        </el-table>
                        </div>
                    </div>
                    <!------------------2020 06-09结束------------------------->
            <!------------------------------------------->
            <!-- <div style="margin-top:10px;"> <span style="font-size: 10pt;" color="#FF0000">{{$t('couse.conditiondesc')}}</span> </div> -->
             <div class="opten-title">
                {{$t('couse.conditionlimit')}}</div>
             <template>
              <el-row :gutter="1">
                <el-col :span="6">
                  <el-form-item label="   ">
                    <div class="dia">
                      <el-radio disabled text-color="#303133" label="0" v-model="inServForm.limitRegistFlag"><span style="color: #303133;">{{ $t('couse.dealer') }}</span></el-radio>
                      <el-radio disabled text-color="#303133" label="1" @change="limitDefineFlagchange()" v-model="inServForm.limitRegistFlag"><span style="color: #303133;">{{ $t('couse.dealerwx') }}</span>
                      </el-radio>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <el-row v-if="inServForm.limitRegistFlag==='0'">
                 <el-col :span="6">
                  <!-- 限定标准-->
                  <div class="location-layout" v-if="inServForm.limitRegistFlag != '1'">
                    <el-form-item :label="$t('couse.xdstandard')" prop="limitCourseFlag">
                      <el-select v-model="inServForm.limitCourseFlag" disabled>
                        <el-option v-for="item in cousebz"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
            <!--开始时间-->
            <el-col :span="12" v-if="inServForm.limitCourseFlag == '10' && inServForm.limitRegistFlag != '1'">
                  <el-col :span="12">
                    <el-form-item :label="$t('couse.limitCourseStartdate')" prop="limitCourseStartdate">
                        <span slot="label">{{$t('couse.limitCourseStartdate')}}
                        <el-tooltip placement="bottom-start" effect="light" popper-class="limit-course-start-date">
                            <div slot="content">
                                学员在此时间段报名，则设置的限制报名人数规则生效，其他时间不生效。
                            </div>
                            <em class="el-icon-question" style="color: #1C69D3"></em>
                        </el-tooltip>
                     </span>
                    <el-date-picker width="60px" v-model="inServForm.limitCourseStartdate" disabled
                    :placeholder="$t('couse.startdate')"
                    value-format="yyyy-MM-dd HH:mm:ss"
                              format="yyyy-MM-dd HH:mm:ss"
                              default-time="09:00:00"
                              type="datetime"
                    :picker-options="pickerOptionsStart" />
                  </el-form-item>
                  </el-col>
                    <el-col :span="12">
                     <el-form-item prop="limitCourseEnddate">
                       <span slot="label">&nbsp;&nbsp;&nbsp;</span>
                    <el-date-picker width="60px" v-model="inServForm.limitCourseEnddate" disabled
                                :placeholder="$t('couse.enddate')"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                format="yyyy-MM-dd HH:mm:ss"
                                default-time="17:00:00"
                                type="datetime"
                                :picker-options="pickerOptionsEnd"/>
                     </el-form-item>
                  </el-col>
              </el-col>
            </el-row>
               <div v-if="inServForm.limitRegistFlag==='0'">
            <el-row :gutter="25" v-if="inServForm.limitRegistFlag==='0'">
              <el-col>
                <el-form-item label="    ">
                  <div v-if="inServForm.limitRegistFlag==='0'||inServForm.limitRegistFlag==='6'">
                    <!-- <el-row :gutter="25"> -->
                      <el-col :span="24">
                        <el-col :span="5">
                            <el-radio disabled @change="limitDefineFlagchangefuz()" v-model="inServForm.limitDefineFlag" label="3" ><span style="color: #303133;">每家经销商限制最多</span></el-radio>
                        </el-col>
                        <el-col :span="19">
                          <el-form-item label="" prop="limitDealerNumber" style="padding-left: 0.5px;padding-right: 12.5px;">
                                                <div id="container">
                                                    <div class="box1">
                                                        <el-input disabled v-model.number="inServForm.limitDealerNumber"
                                                                  style="width: 80px; float: left;">
                                                        </el-input>
                                                    </div>
                                                    <div class="box2"
                                                         style="width: 80px;padding-left: 10.5px; float: left;">
                                                        <span>人报名</span>
                                                    </div>
                                                </div>
                                </el-form-item>
                        </el-col>
                      </el-col>
                      <el-col :span="24">
                        <el-col :span="5">
                            <el-radio disabled @change="limitDefineFlagchangefuuolod" v-model="inServForm.limitDefineFlag" label="1" ><span style="color: #303133;">自定义上传</span></el-radio>
                        </el-col>
                        <div v-if="inServForm.limitDefineFlag === '1'">
                        <el-col :span="19">
                           <div id="container">
                                 <div class="box1" style="padding-left: 0.5px;padding-right: 12.5px;">
                          <!-- <el-button size="small"   @click="upload" disabled
                                      type="primary">点击上传</el-button> -->
                                      </div>
                                     <div class="box1" style="padding-left: 5.5px;padding-right: 12.5px;">
<!--                              <span>除上传经销商外，其他经销商不受限制</span>-->
                              </div>
                           </div>
                        </el-col>
                        </div>
                      </el-col>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            </div>
            <el-row v-if="inServForm.limitRegistFlag==='0'&&inServForm.limitDefineFile!=''">
             <el-col :span="24">
              <el-link type="primary" :underline="false" @click="exportHandle">
                <!-- <el-form-item prop="limitDefineFile"> -->
                 <span>{{inServForm.limitDefineFile}}</span>
                 <!-- </el-form-item> -->
                  </el-link>
              </el-col>
            </el-row>
            <div class="opten-title">
                {{$t('couse.conditionlimitOption')}}</div>
            <el-row >
              <el-col :span="6">
                <!-- 是否限制学习-->
                <el-form-item :label="$t('couse.ynstudyoffering')" prop="limitVisiableFlag">
                  <span slot="label">{{$t('couse.ynstudyoffering')}}
                    <el-tooltip placement="bottom-start" effect="light" >
                      <div slot="content">
                        组群限制生效条件：是否限制查看选择“是”，且选择了面向组群。只有组群内的用户可以查看和报名排期。选择多个组群时，组群间是“或”的关系。
                      </div>
                      <em class="el-icon-question" style="color: #1C69D3"></em>
                    </el-tooltip>
                  </span>
                  <el-select v-model="inServForm.limitVisiableFlag" disabled>
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 站内信推送-->
                <el-form-item :label="$t('couse.zpush')" prop="sendNoticeFlag" >
                  <el-select v-model="inServForm.sendNoticeFlag" disabled>
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
               <el-col :span="6">
                <!-- 允许兼职职位报名-->
                <!-- <el-form-item :label="$t('couse.allowjob')" prop="limitPartTimeJob">
                  <el-select v-model="inServForm.limitPartTimeJob" disabled>
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item> -->
              </el-col>
            </el-row>
            <!-- <div class="opten-title">
                {{$t('couse.csgroututitle')}}</div> -->
            <el-form-item required="true" v-show="inServForm.limitVisiableFlag === '10'" :label="$t('couse.csgroututitle')">
            </el-form-item>
            <el-row :gutter="1" v-show="inServForm.limitVisiableFlag === '10'">
              <el-form-item label="" v-if="inServForm.courseGroupList.length>0">
                <template>
                  <!-- :span-method="arraySpanMethod"  :row-class-name="tableRowClassName"-->
<!--                  <el-table :data="inServForm.courseGroupList"-->
<!--                            :show-header="false"-->
<!--                            >-->
<!--                    <el-table-column prop="groupName"-->
<!--                                    label=""-->
<!--                                    style="width: 80%">-->
<!--                    </el-table-column>-->
<!--                    <el-table-column prop="groupRemark"-->
<!--                                    label=""-->
<!--                                    style="width: 80%">-->
<!--                    </el-table-column>-->
<!--                  </el-table>-->
                    <el-table :data="inServForm.courseGroupList"
                        border
                        style="width:60%">
                            <el-table-column prop="groupName"
                                label="组群名称"
                                header-align="center"
                                align="center"
                                show-overflow-tooltip
                                style="width: 80%">
                            </el-table-column>
                            <el-table-column prop="groupRemark"
                                label="组群描述"
                                header-align="center"
                                align="center"
                                show-overflow-tooltip
                                style="width: 80%">
                            </el-table-column>
                               <el-table-column prop="createUserName"
                                       header-align="center"
                                       align="center"
                                       show-overflow-tooltip
                                       label="创建人" >
                      </el-table-column>
                    </el-table>
                </template>
              </el-form-item>
            </el-row>
            <div class="opten-title">
                {{$t('couse.equestitle')}}</div>
              <el-row :gutter="1">
               <el-form-item label="" v-if="inServForm.courseEqualDTOList.length>0">
                <template>
                  <el-table  style="width: 720px;" border
                  :cell-style="cellStylec"
                  :data="inServForm.courseEqualDTOList"
                  :span-method="arraySpanMethod">
                     <el-table-column prop="combName"
                                    :label="$t('couse.equecombination')"
                                    :width="100"
                                    align="center"
                                    show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="equalPackageNo"
                                    :label="$t('couse.equespackage')"
                                    :width="80"
                                    align="center"
                                    show-overflow-tooltip
                                    :formatter="equespackageformat">
                    </el-table-column>
                    <el-table-column prop="courseCode"
                                    :label="$t('couse.equescoursecode')"
                                    :width="150"
                                    align="center"
                                    show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="courseName"
                                     :label="$t('couse.equesname')"
                                     :width="150"
                                    align="center"
                                    show-overflow-tooltip>
                    </el-table-column>
                     <el-table-column prop="learningObjectFlag"
                                      :label="$t('couse.equestype')"
                                      :width="120"
                                    align="center"
                                    show-overflow-tooltip
                                    :formatter="kindformat">
                    </el-table-column>
                      <!--  -->
                     <el-table-column prop="courseStatus"
                                      :label="$t('couse.equesstate')"
                                      :width="119"
                                    align="center"
                                    show-overflow-tooltip
                                    :formatter="statusformat"
                                    >
                    </el-table-column>
                  </el-table>
                </template>
              </el-form-item>
            </el-row>
          </el-form>
       </el-card>
      <div>
            <el-row style="float:right; margin-bottom: 60px;">
                <el-col :span="16"><div class="grid-content" /></el-col>
                <el-button @click="sendEdit" v-if = initIsShowEdit
                           type="primary">{{ $t("course.edit") }}</el-button>
                <el-button @click="btnSaveNextStep"
                           type="primary">{{ $t("course.next") }}</el-button>
            </el-row>
        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 基本信息   offbaseAdd
// 报名条件   offconditionAdd
// 报名通知   offnoticeAdd
// 价格相关   offpriceAdd
// 调查问卷   offinvestAdd
// 能力项设置 offabilityAdd
import coursedcreat from '../../common/coursedcreat'
// import course from '../../common/course'
// import debounce from 'lodash/debounce'
import conditionShow from './offeringconditionzShow'
import blendconditionShow from './blendofferingconditionzShow'
import Steps from '../../common/steps/index'
import Step from '../../common/steps/src/step'
export default {
// import引入的组件需要注入到对象中才能使用
  components: { Steps,
    Step,
    coursedcreat,
    conditionShow ,
    blendconditionShow},
  props: ['message', 'passOfferingId', 'isShowEdit'],
  inject: ['toTop'],
  data () {
    return {
      initIsShowEdit:'',
      mixinViewModuleOptions: {
      },
      dialogTableVisible: false,
      courseId: '',
      importExcelVisible1: false,
      importExcelVisible: false,
      s1: '2',
      value: '',
      activ: 0,
      cousedaylist: [{
        value: 'd',
        label: '天'
      }, {
        value: 'h',
        label: '小时'
      }],
      couseyesno: [{
        value: '10',
        label: '是'
      }, {
        value: '20',
        label: '否'
      }],
      // 限定标准
      cousebz: [{
        value: '10',
        label: '按课程'
      }, {
        value: '20',
        label: '按排期'
      }],
      initcon: [],
      infiledLists2: [{ options: 1 }],
      courseBlendDisplay:false,
      inServForm: {
        deadLineFlag: 'd',
        courseConditionList: [],
        courseBlendConditionList: [],
        offeringBlendRead: '',
        courseLimidealerList: [],
        courseGroupList: [],
        courseEqualDTOList: [],
        menuId: '',
        addressbaidu: 1,
        radio: '',
        chekex1: '',
        chekex2: '',
        active: 0,
        id: 45,
        sort: 0,
        courejoblist: [],
        waitingListFlag: '',
        offeringStatus:'',
        courseTeamCatalogSecond:''
      },
      needMergeArr: ['combName', 'equalPackageNo'], // 有合并项的列
      rowMergeArrs: {}, // 包含需要一个或多个合并项信息的对象
      dataRulez: {
        waitingListFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        coursePrice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      },
      dataForm: {
        offeringId: ''
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {
    dataRule () {
      let limitCourseStartdate = (rule, value, callback) => {
        if (this.inServForm.limitCourseEnddate !== null || this.inServForm.limitCourseEnddate !== ' ') {
          if (value === this.inServForm.limitCourseEnddate && value === 0) {
            callback()
          }
          if (value >= this.inServForm.limitCourseEnddate) {
            callback(new Error('开始日期不能大于结束日期'))
          }
        }
        callback()
      }
      let limitCourseEnddate = (rule, value, callback) => {
        if (this.inServForm.limitCourseEnddate === undefined || this.inServForm.limitCourseEnddate === null || this.inServForm.limitCourseEnddate === '') {
          callback(new Error(this.$t('validate.required')))
        }
        if (this.inServForm.limitCourseStartdate !== null || this.inServForm.limitCourseStartdate !== ' ') {
          if (value === this.inServForm.limitCourseStartdate && value === 0) {
            callback()
          }
          if (value <= this.inServForm.limitCourseStartdate) {
            callback(new Error('结束日期不能小于开始日期'))
          }
        }
        callback()
      }
      return {
        courseConditionStatus: [{ type: 'string', required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        replaceUserFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        collectionDemandFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        revokeRegistFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        revokeRegistDays: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        repeatRegistFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        limitVisiableFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        sendNoticeFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        limitPartTimeJob: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        waitingListFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deadLineDays: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        limitDealerNumber: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        limitCourseStartdate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: limitCourseStartdate, trigger: 'blur' }
        ],
        limitCourseEnddate: [
          { validator: limitCourseEnddate, trigger: 'blur' }
        ],
        limitCourseFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
      this.dataForm.offeringId = this.$route.query.offeringId
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    console.log('mounted')
  },
  beforeCreate () {
    console.log('beforeCreate')
  }, // 生命周期 - 创建之前
  beforeMount () {
    console.log('beforeMount')
  }, // 生命周期 - 挂载之前
  beforeUpdate () {
    console.log('beforeUpdate')
  }, // 生命周期 - 更新之前
  updated () {
    console.log('updated')
  }, // 生命周期 - 更新之后
  beforeDestroy () {
    console.log('beforeDestroy')
  }, // 生命周期 - 销毁之前
  destroyed () {
    console.log('destroyed')
  }, // 生命周期 - 销毁完成
  activated () {
    if (this.$route.query.offeringId !== undefined && this.$route.query.offeringId !== '') {
      // #TODO 再次进入页面初始化数据
      console.log('再次进入 sigUpConditions')
      console.log(this.$route.query.offeringId)
      this.init(this.$route.query.offeringId)
    }
    if (this.$route.query.isShowEdit !== undefined && this.$route.query.isShowEdit !== '') {
      this.initIsShowEdit = this.$route.query.isShowEdit
    }
  },
  // 方法集合
  methods: {
    equespackageformat (row, column, cellValue){
     return this.getCaption(cellValue,1)  //输出
    },
		getCaption(obj,state) {
    var index=obj.lastIndexOf('\*');
    if(state==0){
        obj=obj.substring(0,index);
    }else {
        obj=obj.substring(index+1,obj.length);
    }
    return obj;
   },
    // 课程状态
    statusformat (row, column, cellValue) {
      if (cellValue === '10') {
        return '未发布'
      } else if (cellValue === '20') {
        return '已发布'
      } else if (cellValue === '30') {
        return '已下架'
      } else { return ' ' }
    },
    // 课程类型
    kindformat (row, column, cellValue) {
      if (cellValue === '10') {
        return '面授课'
      } else if (cellValue === '20') {
        return '微课'
      } else if (cellValue === '30') {
        return '慕课'
      } else if (cellValue === '40') {
        return '混合式学习'
      } else if (cellValue === '50') {
        return 'WBT'
      }else { return ' ' }
    },
    arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      // 没办法循环判断具体是那一列 所以就只好写了多个if
      if (column.property === 'combName') return this.mergeAction('combName', rowIndex, column)
      if (column.property === 'equalPackageNo') return this.mergeAction('equalPackageNo', rowIndex, column)
    },
    mergeAction (val, rowIndex, colData) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      let _row = this.rowMergeArrs[val].rowArr[rowIndex]
      let _col = _row > 0 ? 1 : 0
      return [_row, _col]
    },
    rowMergeHandle (arr, data) {
      if (!Array.isArray(arr) && !arr.length) return false
      if (!Array.isArray(data) && !data.length) return false
      let needMerge = {}
      arr.forEach(i => {
        needMerge[i] = {
          rowArr: [],
          rowMergeNum: 0
        }
        data.forEach((item, index) => {
          if (index === 0) {
            needMerge[i].rowArr.push(1)
            needMerge[i].rowMergeNum = 0
          } else {
            if (item[i] === data[index - 1][i]) {
              needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1
              needMerge[i].rowArr.push(0)
            } else {
              needMerge[i].rowArr.push(1)
              needMerge[i].rowMergeNum = index
            }
          }
        })
      })
      return needMerge
    },
    cellStylec ({ row, column, rowIndex, columnIndex }) {
      return {
        background: '#fff'
      }
    },
    exportHandle () {
      // download 参数 url, params, 报表名
      var filename = this.inServForm.limitDefineFile.replace('.xls', '')
      this.$request.download('/learning/base/offeringinfo/limitdownload', filename, { limitDefineFileid: this.inServForm.limitDefineFileid })
    },
    cellStyle ({ row, column, rowIndex, columnIndex }) {
      if (column.property) {
        return {
          background: '#ebecf0 !important',
          color: '#333333'
        }
      }
    },
    // 设置初始化为空
    again () {
      // TODO data 数据设置为空
    },
    // 初始化数据
    init (offeringId) {
      // TODO data 初始化数据
      // TODO data 初始化数据
      // TODO data 初始化数据
      // TODO data 初始化数据
      // TODO data 初始化数据
      // TODO data 初始化数据
      this.inServForm.courseId = offeringId
      this.getDealerBeforeGetInfo()
    },
    getDealerBeforeGetInfo () {
      // this.$request.post(`/learning/course/courseinfo/courseConditionUpdate`,
      this.$request.get('/learning/base/offeringinfo/offeringConditionList',
        { courseId: this.inServForm.courseId }
      ).then((res, total, code, data) => {
        this.inServForm = data.data
        // this.getInfo()
        if (this.inServForm.limitDefineFlag === null) {
          this.inServForm.limitRegistFlag = '1'
          this.inServForm.limitDefineFlag = '3'
        }
          if(this.inServForm.courseBlendConditionList.length > 0){
              this.courseBlendDisplay=true
          }else {
              this.courseBlendDisplay=false
          }
        this.rowMergeArrs = this.rowMergeHandle(this.needMergeArr, this.inServForm.courseEqualDTOList) // 处理数据

      }).catch((err) => {
        console.log(err)
      })
    },
    // 保存方法
    btnSave () {
      // TODO 成功调用  this.sendSave()
    },
    // 保存并下一步
    btnSaveNextStep () {
      // TODO  成功调用 this.sendMsg()
      this.sendMsg()
    },
    // 向父页面传递消息 跳转下一页面
    sendMsg () {
      this.toTop()
      this.$emit('onShowModer', 'offnoticesend')
    },
    // 向父页面传递消息 保存页面
    sendSave () {
      this.$emit('onShowModer', 'offnoticeSave')
    },
    // 点击导航跳转页面
    on_click (e) {
      this.$emit('onShowModer', e)
    },
    // 取消按钮
    btnCancel () {
      this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tabRemove()
      }).catch((err) => {
        console.log(err)
      })
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    },
    sendEdit(){
      console.log("sendEdit")
      this.$router.push({ path: 'learning-offering-offeringEdit', query: { offeringId: this.dataForm.offeringId } })
    },
    checkEditRole () {
      if (this.inServForm.offeringStatus === '30' || this.inServForm.offeringStatus === '40') {
          return false
      }
      if (this.$hasPermission('learning:offering:offeringEdit')) {
          return true
      }
      if (this.$hasPermission('TEAM:' + this.inServForm.courseTeamCatalogSecond)) {
          return true
      }
      if (this.$hasPermission('learning:offering:editselfcreated')) {
          return true
      }
      return false
    }
  }
}
</script>
<style>
    .limit-course-start-date {
        max-width: 28rem !important;
    }
</style>
<style lang='scss' scoped>
 .el-form--label-top .el-form-item__label {
    padding: 0px !important;
    width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
  // @import url(); 引入公共css类
  .grid-content {
      border-radius: 4px;
      min-height: 36px;
  }
  .box1 {
    float: left;
  }
  .box2 {
    float: left;
  }
</style>
